<ng-container *ngIf="showCurrentQuery; else noQueryView">
  <div data-test="query-view" class="color-900 d-flex flex-column">
    <span class="headline text-center">{{ subtitle }}</span>
    <span data-test="no-results-text" class="h2 text-center">{{ currentQueryText }}</span>
    <p class="headline text-center">Check your spelling, try different keywords, or adjust your filters.</p>
  </div>
</ng-container>

<ng-template #noQueryView>
  <div data-test="no-query-view" class="color-900 d-flex flex-column">
    <span class="headline text-center bold">{{ noQueryTitle }}</span>
    <p class="headline text-center">{{ noQueryText }}</p>
  </div>
</ng-template>
